// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cff-field {
  display: flex;
  flex-direction: column;
  gap: var(--cui-field-gap);
  width: 100%;
  min-width: 0;
  margin-bottom: var(--cui-field-margin);
}

.cff-noMargin {
  margin-bottom: 0;
}

.cff-label {
  margin: 0;
  font-size: var(--cui-label-size);
  font-weight: 600;
  line-height: 1.35;
  color: var(--cui-text-label);
}

.cff-required {
  margin-left: 3px;
  color: var(--cui-danger);
}

.cff-body {
  display: flex;
  flex-direction: column;
  gap: 5px;
  min-width: 0;
}

/* Red error message */
.cff-error {
  display: flex;
  align-items: flex-start;
  gap: 5px;
  font-size: var(--cui-font-size-sm);
  line-height: 1.4;
  color: var(--cui-danger);
}

.cff-error svg {
  flex-shrink: 0;
  margin-top: 1px;
}

.cff-hint {
  font-size: var(--cui-font-size-sm);
  line-height: 1.4;
  color: var(--cui-text-muted);
}

/* Label beside the control on tablets and up; stacks again on phones */
@media (min-width: 768px) {
  .cff-row {
    flex-direction: row;
    align-items: flex-start;
    gap: 12px;
  }

  .cff-row > .cff-label {
    flex: 0 0 34%;
    max-width: 34%;
    padding-top: 10px;
  }

  .cff-row > .cff-body {
    flex: 1 1 auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Component/CustomFormField/CustomFormField.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,kCAAkC;EAClC,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA,uEAAuE;AACvE;EACE;IACE,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":[".cff-field {\n  display: flex;\n  flex-direction: column;\n  gap: var(--cui-field-gap);\n  width: 100%;\n  min-width: 0;\n  margin-bottom: var(--cui-field-margin);\n}\n\n.cff-noMargin {\n  margin-bottom: 0;\n}\n\n.cff-label {\n  margin: 0;\n  font-size: var(--cui-label-size);\n  font-weight: 600;\n  line-height: 1.35;\n  color: var(--cui-text-label);\n}\n\n.cff-required {\n  margin-left: 3px;\n  color: var(--cui-danger);\n}\n\n.cff-body {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  min-width: 0;\n}\n\n/* Red error message */\n.cff-error {\n  display: flex;\n  align-items: flex-start;\n  gap: 5px;\n  font-size: var(--cui-font-size-sm);\n  line-height: 1.4;\n  color: var(--cui-danger);\n}\n\n.cff-error svg {\n  flex-shrink: 0;\n  margin-top: 1px;\n}\n\n.cff-hint {\n  font-size: var(--cui-font-size-sm);\n  line-height: 1.4;\n  color: var(--cui-text-muted);\n}\n\n/* Label beside the control on tablets and up; stacks again on phones */\n@media (min-width: 768px) {\n  .cff-row {\n    flex-direction: row;\n    align-items: flex-start;\n    gap: 12px;\n  }\n\n  .cff-row > .cff-label {\n    flex: 0 0 34%;\n    max-width: 34%;\n    padding-top: 10px;\n  }\n\n  .cff-row > .cff-body {\n    flex: 1 1 auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
